module.exports = __webpack_public_path__ + "static/media/22.2f2463c1.png";